import AddIcon from './AddIcon.svg';
import AlertCircleIcon from './AlertCircleIcon.svg';
import ArchiveBigIcon from './ArchiveBigIcon.svg';
import ArchiveIcon from './ArchiveIcon.svg';
import ArrowRightIcon from './ArrowRightIcon.svg';
import ArrowSquareRightIcon from './ArrowSquareRightIcon.svg';
import CalendarDateIcon from './CalendarDateIcon.svg';
import CheckBigIcon from './CheckBigIcon.svg';
import CheckCircleIcon from './CheckCircleIcon.svg';
import CheckGreenIcon from './CheckGreenIcon.svg';
import CheckIcon from './CheckIcon.svg';
import CheckVerifiedIconBig from './CheckVerifiedIconBig.svg';
import ChevronDownIcon from './ChevronDownIcon.svg';
import CircleCheckedIcon from './CircleCheckedIcon.svg';
import CircleIcon from './CircleIcon.svg';
import CloseIcon from './CloseIcon.svg';
import ColorAddCircleIcon from './ColorAddCircleIcon.svg';
import ColorAlertIcon from './ColorAlertIcon.svg';
import ColorCheckCircleIcon from './ColorCheckCircleIcon.svg';
import ColorErrorIcon from './ColorErrorIcon.svg';
import ColorFileIcon from './ColorFileIcon.svg';
import ColorFileMinusIcon from './ColorFileMinusIcon.svg';
import ColorLockIcon from './ColorLockIcon.svg';
import ColorMailIcon from './ColorMailIcon.svg';
import ColorRemoveIcon from './ColorRemoveIcon.svg';
import ColorSearchIcon from './ColorSearchIcon.svg';
import ColorShieldIcon from './ColorShieldIcon.svg';
import ColorSignatureIcon from './ColorSignatureIcon.svg';
import ColorUploadFileIcon from './ColorUploadFileIcon.svg';
import ColorUserIcon from './ColorUserIcon.svg';
import ColorWarningIcon from './ColorWarningIcon.svg';
import DateIcon from './DateIcon.svg';
import DateIconActive from './DateIconActive.svg';
import DeleteIcon from './DeleteIcon.svg';
import DiscordIcon from './DiscordIcon.svg';
import DotIcon from './DotIcon.svg';
import DotsVertical from './DotsVertical.svg';
import DownloadIcon from './DownloadIcon.svg';
import EditIcon from './EditIcon.svg';
import EmailIcon from './EmailIcon.svg';
import EmailIcon1 from './EmailIcon1.svg';
import EmptyIcon from './EmptyIcon.svg';
import EyeIcon from './EyeIcon.svg';
import FileIcon from './FileIcon.svg';
import FolderBigIcon from './FolderBigIcon.svg';
import FolderCircleIcon from './FolderCircleIcon.svg';
import FolderIcon from './FolderIcon.svg';
import GoogleIcon from './GoogleIcon.svg';
import HomeBigIcon from './HomeBigIcon.svg';
import HomeIcon from './HomeIcon.svg';
import LogoutIcon from './LogoutIcon.svg';
import QuestionMarkCircleIcon from './QuestionMarkCircleIcon.svg';
import SearchIcon from './SearchIcon.svg';
import ShieldIcon from './ShieldIcon.svg';
import SignPreviewIcon from './SignPreviewIcon.svg';
import SignatureIcon from './SignatureIcon.svg';
import SignatureIconActive from './SignatureIconActive.svg';
import StepIcon from './StepIcon.svg';
import StepIconGray from './StepIconGray.svg';
import SubtractIcon from './SubtractIcon.svg';
import TelegramIcon from './TelegramIcon.svg';
import TelegramIcon1 from './TelegramIcon1.svg';
import TextIcon from './TextIcon.svg';
import TextIconActive from './TextIconActive.svg';
import TrashIcon from './TrashIcon.svg';
import TwitterIcon from './TwitterIcon.svg';
import TwitterIcon1 from './TwitterIcon1.svg';
import UnOrderListIcon from './UnOrderListIcon.svg';
import UploadBigIcon from './UploadBigIcon.svg';
import UploadIcon from './UploadIcon.svg';
import UserIcon from './UserIcon.svg';
import WalletIconMini from './WalletIconMini.svg';
import WarningIcon from './WarningIcon.svg';
import CardanoIcon from './walletIcons/CardanoIcon.svg';
import CoinbaseIcon from './walletIcons/CoinbaseIcon.svg';
import LeatherIcon from './walletIcons/LeatherIcon.svg';
import MetamaskIcon from './walletIcons/MetamaskIcon.svg';
import OkxIcon from './walletIcons/OkxIcon.svg';
import OpenmaskIcon from './walletIcons/OpenmaskIcon.svg';
import ParticleIcon from './walletIcons/ParticleIcon.svg';
import PetraIcon from './walletIcons/PetraIcon.svg';
import PhantomIcon from './walletIcons/PhantomIcon.svg';
import StarkNetIcon from './walletIcons/StarkNetIcon.svg';
import TonIcon from './walletIcons/TonIcon.svg';
import UnisatIcon from './walletIcons/UnisatIcon.svg';
import WalletConnectIcon from './walletIcons/WcIcon.svg';

const Icon = (props: any) => <img width={40} height={40} {...props} />;
const SingPassIcon = (props: any) => (
  <Icon
    width={32}
    height={32}
    src="https://sign-public-cdn.s3.us-east-1.amazonaws.com/signature-next/singpass_240723073630.webp"
    {...props}
  />
);

const UAEIcon = (props: any) => (
  <Icon
    width={32}
    height={32}
    src="https://sign-public-cdn.s3.us-east-1.amazonaws.com/signature-next/uae-icon_250603071806.webp"
    {...props}
  />
);

const LogoIconLight = (props: any) => (
  <Icon
    width={96}
    height={40}
    src="https://sign-public-cdn.s3.us-east-1.amazonaws.com/signature-next/logo-white_230823022528_240723062316.webp"
    {...props}
  />
);
const LogoIcon = (props: any) => (
  <Icon
    width={96}
    height={40}
    src="https://sign-public-cdn.s3.us-east-1.amazonaws.com/signature-next/logo_240723073922.webp"
    {...props}
  />
);

export {
  ColorErrorIcon,
  ColorSignatureIcon,
  StepIcon,
  StepIconGray,
  CheckGreenIcon,
  CircleCheckedIcon,
  DateIcon,
  DateIconActive,
  TextIcon,
  TextIconActive,
  SignatureIcon,
  SignatureIconActive,
  UserIcon,
  CheckBigIcon,
  CircleIcon,
  FolderBigIcon,
  HomeBigIcon,
  FolderCircleIcon,
  ArchiveBigIcon,
  ArrowSquareRightIcon,
  DownloadIcon,
  FileIcon,
  TrashIcon,
  EditIcon,
  MetamaskIcon,
  LeatherIcon,
  OpenmaskIcon,
  PetraIcon,
  PhantomIcon,
  LogoIcon,
  AddIcon,
  ArrowRightIcon,
  CheckIcon,
  DeleteIcon,
  FolderIcon,
  SubtractIcon,
  UnOrderListIcon,
  TelegramIcon,
  EmailIcon,
  WalletIconMini,
  HomeIcon,
  ArchiveIcon,
  LogoutIcon,
  WarningIcon,
  ShieldIcon,
  EmptyIcon,
  DotsVertical,
  ChevronDownIcon,
  EyeIcon,
  CloseIcon,
  AlertCircleIcon,
  QuestionMarkCircleIcon,
  UploadIcon,
  UploadBigIcon,
  DotIcon,
  CalendarDateIcon,
  ColorRemoveIcon,
  SearchIcon,
  SignPreviewIcon,
  GoogleIcon,
  TwitterIcon,
  CheckCircleIcon,
  ColorUserIcon,
  ColorSearchIcon,
  ParticleIcon,
  ColorMailIcon,
  ColorFileIcon,
  ColorShieldIcon,
  LogoIconLight,
  OkxIcon,
  TonIcon,
  ColorAlertIcon,
  SingPassIcon,
  ColorCheckCircleIcon,
  DiscordIcon,
  TwitterIcon1,
  TelegramIcon1,
  EmailIcon1,
  ColorUploadFileIcon,
  ColorWarningIcon,
  CheckVerifiedIconBig,
  ColorFileMinusIcon,
  ColorAddCircleIcon,
  WalletConnectIcon,
  StarkNetIcon,
  CardanoIcon,
  UnisatIcon,
  CoinbaseIcon,
  ColorLockIcon,
  UAEIcon
};
